import { useDispatch } from "react-redux";
import { SelectChangeEvent } from "@mui/material";
import ScheduleCard from "./ScheduleCard";
import { updateTiming } from "../../../../../store/steps/stepFourSlice";
import GenericSelect from "../../../../../common/GenericSelect";
import { STATIC_STRINGS } from "../../../../../utils/Constants";

const Duration = ({ timing, scheduleSetting, handleOptionClick }) => {
  const dispatch = useDispatch();

  const handleUnitChange = (e: SelectChangeEvent) =>
    dispatch(updateTiming({ unit: e.target.value, duration: 1 }));

  const handleDurationChange = (e: SelectChangeEvent) =>
    dispatch(
      updateTiming({
        unit: timing.unit,
        duration: Number(e.target.value),
      })
    );

  const getOptions = (unit?: string): { label: string; value: string }[] => {
    const length = unit === STATIC_STRINGS.DAYS ? 30 : 24;
    return Array.from({ length }, (_, i) => ({
      label: `${i + 1} ${unit ?? STATIC_STRINGS.HOURS}`,
      value: (i + 1).toString(),
    }));
  };

  return (
    <ScheduleCard
      className="w-[45%]"
      selected={scheduleSetting === STATIC_STRINGS.DURATION}
      onClick={() => handleOptionClick(STATIC_STRINGS.DURATION)}
      title={STATIC_STRINGS.DURATION}
      subtitle={STATIC_STRINGS.DURATION_PHRASE}
    >
      <div className="font-semibold text-gray-500 p-0">
        {STATIC_STRINGS.DURATION}
      </div>
      <div className="flex items-center">
        <div>
          <GenericSelect
            className="w-24"
            disabled={scheduleSetting !== STATIC_STRINGS.DURATION}
            value={timing.unit || STATIC_STRINGS.HOURS}
            onChange={handleUnitChange}
            options={[
              { label: STATIC_STRINGS.HOURS, value: STATIC_STRINGS.HOURS },
              { label: STATIC_STRINGS.DAYS, value: STATIC_STRINGS.DAYS },
            ]}
          />
        </div>
        <div className="ml-2">
          <GenericSelect
            className="w-32"
            disabled={scheduleSetting !== STATIC_STRINGS.DURATION}
            onChange={handleDurationChange}
            value={timing.duration?.toString() ?? "1"}
            options={getOptions(timing.unit)}
          />
        </div>
      </div>
    </ScheduleCard>
  );
};

export default Duration;
